<script>
    import { doJSON, handleError } from "./lib";
    import AutoComplete from "simple-svelte-autocomplete"
    import user from "./stores";
    export let params;
    import { push } from "svelte-spa-router";

    if(!$user.is_admin && !$user.agency_approvals) {
        push('/');
    }

    let new_budget_year = false;

    let item = {
        'address': {},
        'budgets': [],
        'users': [],
        'account_id': $user.account_id
    };
    let name = 'dealer';
    let chosen_user = false;
    let ui_name = 'Dealer';
    let submitted = false;
    let method = 'PUT';
    let url = '';
    let message = {};
    let districts = [];

    function addYear(event) {
        if(event.type == 'keydown') {
            if(event.key != 'Enter') {
                return;
            } else {
                event.preventDefault();
            }
        }

        if(!new_budget_year) {
            alert('Please enter a year');
            return;
        }

        if(item.budgets.find(b => b.year == new_budget_year)) {
            alert('That year already exists');
            return;
        }

        item.budgets.push({'year': new_budget_year});
        item.budgets = item.budgets;
        new_budget_year = false;
    }

    async function init() {
        method = 'PUT';
        url = `/api/${name}`;

        let [success, response] = await doJSON('/api/district', false, 'GET');
        districts = response.data;

        if(params.id == 'new') {
            method = 'POST';
        } else {
            url += '/' + params.id;
            let [success, response] = await doJSON(url, false, 'GET');
            if(success) {
                item = response;
            }
        }
    }

    async function submit() {
        message = {};

        let [success, response] = await doJSON(url, item, method);
        if(success) {

            message = {
                'text': `The ${name} has been updated`,
                'class': 'success'
            }

            item = response;
            init();
        } else {
            message = await handleError(response, message);
        }
        document.getElementById('main').scrollTo({'top': 0, 'left': 0, 'behavior': 'smooth'});
    }

    function addUser() {
        if(chosen_user) {
            item.users.push(chosen_user);
            chosen_user = undefined;
            item.users = item.users;

            var clearButton = document.querySelector('#addUser .autocomplete-clear-button');
            if(clearButton) {
                clearButton.click();
            }
        }
    }

    async function searchUsers(keyword) {
        let [success, response] = await doJSON('/api/user?q=' + keyword, null, 'GET');
        if(success) {
            return response.data;
        }
    }   

    init();


</script>

<h1>Edit { ui_name }</h1>
{#if message.text}
    <div class="msg {message.class}">{message.text}</div>
{/if}
<form autocomplete="off" class:submitted="{submitted}" on:submit|preventDefault="{submit}">
    <label>
        <span class="label">Dealer Number</span>
        <input required bind:value="{item.number}" />
    </label>
    <label>
        <span class="label">Name</span>
        <input required bind:value="{item.name}" />
    </label>
    <label>
        <span class="label">ADI</span>
        <input required bind:value="{item.adi}" />
    </label>
    {#if item.account_id == 1}
    <label>
        <span class="label">District</span>
        <select bind:value="{item.district_id}">
            <option value=""></option>
            {#each districts as district}
                <option value="{district.id}">{district.name}</option>
            {/each}
        </select>
    </label>
    {/if}

    <label>
        <span class="label">Street Address</span>
        <input required bind:value="{item.address.address}" />
    </label>

    <label>
        <span class="label">City</span>
        <input required bind:value="{item.address.city}" />
    </label>

    <label>
        <span class="label">State</span>
        <select required bind:value="{item.address.state}">
            <option value=""></option>
            <option value="AL">Alabama</option> <option value="AK">Alaska</option> <option value="AS">American Samoa</option> <option value="AZ">Arizona</option> <option value="AR">Arkansas</option> <option value="CA">California</option> <option value="CO">Colorado</option> <option value="CT">Connecticut</option> <option value="DE">Delaware</option> <option value="DC">District of Columbia</option> <option value="FL">Florida</option> <option value="GA">Georgia</option> <option value="GU">Guam</option> <option value="HI">Hawaii</option> <option value="ID">Idaho</option> <option value="IL">Illinois</option> <option value="IN">Indiana</option> <option value="IA">Iowa</option> <option value="KS">Kansas</option> <option value="KY">Kentucky</option> <option value="LA">Louisiana</option> <option value="ME">Maine</option> <option value="MH">Marshall Islands</option> <option value="MD">Maryland</option> <option value="MA">Massachusetts</option> <option value="MI">Michigan</option> <option value="MN">Minnesota</option> <option value="MS">Mississippi</option> <option value="MO">Missouri</option> <option value="MT">Montana</option> <option value="NE">Nebraska</option> <option value="NV">Nevada</option> <option value="NH">New Hampshire</option> <option value="NJ">New Jersey</option> <option value="NM">New Mexico</option> <option value="NY">New York</option> <option value="NC">North Carolina</option> <option value="ND">North Dakota</option> <option value="OH">Ohio</option> <option value="OK">Oklahoma</option> <option value="OR">Oregon</option> <option value="PW">Palau</option> <option value="PA">Pennsylvania</option> <option value="PR">Puerto Rico</option> <option value="RI">Rhode Island</option> <option value="SC">South Carolina</option> <option value="SD">South Dakota</option> <option value="TN">Tennessee</option> <option value="TX">Texas</option> <option value="UT">Utah</option> <option value="VT">Vermont</option> <option value="VI">Virgin Islands</option> <option value="VA">Virginia</option> <option value="WA">Washington</option> <option value="WV">West Virginia</option> <option value="WI">Wisconsin</option> <option value="WY">Wyoming</option> 
        </select>
    </label>

    <label>
        <span class="label">Zip</span>
        <input required bind:value="{item.address.zip}" />
    </label>

    <h2>Budgets</h2>
    <table class="table">
        <thead>
            <tr>
                <th>Year</th>
                <th>Amount</th>
            </tr>
        </thead>
        <tbody>
            {#if !item.budgets || item.budgets.length == 0}
                <tr>
                    <td colspan="2">No budgets</td>
                </tr>
            {:else}
            {#each item.budgets as budget}
                <tr>
                    <td>{budget.year}</td>
                    <td><input bind:value={budget.amount}  type="number" step="0.01" /></td>
                </tr>
            {/each}
            {/if}
        </tbody>
    </table>

    <div class="add_year">
        <label>
            <span class="label">Add A Budget Year</span>
            <input on:keydown={addYear} type="number" step="1" bind:value="{new_budget_year}" placeholder="2024"/>
        </label>
        <input type="button" class="btn" value="Add" on:click="{addYear}" />
    </div>  


    <h2>Users</h2>
    <table class="table">
        <thead>
            <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Delete</th>
            </tr>
        </thead>
        <tbody>
            {#if !item.users || item.users.length == 0}
                <tr>
                    <td colspan="3">No users</td>
                </tr>
            {:else}
            {#each item.users as user, idx}
                <tr>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td><button type="button" on:click={() => { item.users.splice(idx, 1); item.users = item.users }}>X</button></td>
                </tr>
            {/each}
            {/if}
        </tbody>
    </table>

    <p>
    <label for="add-user" id="addUser">
        <AutoComplete
            id="add-user"
            searchFunction={searchUsers}
            placeholder="Add a user..."
            delay="200"
            localFiltering={false}
            lock="false"
            labelFieldName="name"
            minCharactersToSearch="-1"
            bind:selectedItem="{chosen_user}"
            onChange="{addUser}"
            >
            <div slot="item" let:item="{item}">
                <div class="autocomplete-item">
                    <span class="autocomplete-item__name">{item.name}</span> -
                    <span class="autocomplete-item__email">{item.email}</span>
                </div>
            </div>
        </AutoComplete>
    </label>    
    </p>

    <p><button on:click="{() => { submitted = true}}" class="btn u-w100">SUBMIT</button></p>
</form> 

<style>

    .add_year {
        text-align: right;
        padding-top: 12px;
    }

    .add_year label {
        display: inline-block;
    }

    .add_year span.label {
        display: inline-block;
        width: fit-content;
    }

    .add_year input {
        display: inline-block;
        width: 8em;
    }

</style>